export default __webpack_public_path__ + "static/media/audit.afff4fa6.svg";